import { Grid, Container, Stepper, Step, StepLabel, Button, Card, CardContent } from '@mui/material'

import { GeneralInfoStep } from './GeneralInfoStep'
import { StampsStep } from './StampsStep'
import { DefaultFinishStep } from './DefaultFinishStep'
import { ArrowLeft } from 'react-feather'

const steps = ['Info General', 'Timbres']

export const FormLegalDocuments = ({ useFetchInit }) => {

    const {
        globalStates,
        Actions
    } = useFetchInit

    const {formOpeningMode, stepApplilication } = globalStates

    const { handleClickReturnStep, handleClickCloseForm } = Actions

    const readOnlyMode = formOpeningMode === 'READONLY'

    const getStepContent = (stepApplilication) => {
            switch (stepApplilication) {
                case 0:
                    return <GeneralInfoStep
                        useFetchInit = {useFetchInit}
                        readOnlyMode = {readOnlyMode}
                    />
                case 1:
                    return <StampsStep
                        useFetchInit = {useFetchInit}
                        readOnlyMode = {readOnlyMode}
                    />;
                default:
                    throw new Error('Unknown step');
            }
        }

    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card style={{zIndex:'1'}}>
                    <CardContent>
                        <Button
                            startIcon={<ArrowLeft/>}
                            variant='text'
                            color='error'
                            size='large'
                            sx={{ marginTop: 2, marginBottom : 2 }}
                            onClick={handleClickCloseForm}
                        >
                            Volver a la pantalla anterior
                        </Button>
                        <div className="border-bottom border-dark"></div>

                        <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
                            <Stepper activeStep={stepApplilication} sx={{ pt: 3, pb: 5 }}>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Container>

                        <p className='text-danger'>* campos obligatorios</p>
                        {stepApplilication === steps.length ? (
                            <DefaultFinishStep
                                handleClickReturnStep={handleClickReturnStep}
                                handleClickCloseForm={handleClickCloseForm}
                            />

                        ) : (
                            <>
                                {getStepContent(stepApplilication)}
                            </>
                        )}
                    </CardContent>
                </Card>
            </Grid> 
        </Grid>
    )
}
